import * as t from "io-ts";
import { GlobalColorV } from "@/types/colors";
import { UnitInputValue } from "@/types/unit";

export const ColorScaleV = t.type({
  100: GlobalColorV,
  200: GlobalColorV,
  300: GlobalColorV,
  400: GlobalColorV,
  500: GlobalColorV,
  600: GlobalColorV,
  700: GlobalColorV,
  800: GlobalColorV,
  900: GlobalColorV
});

export const NamedColorPaletteV = t.type({
  label: t.string,
  primary: t.boolean,
  locked: t.boolean,
  base: GlobalColorV,
  scale: ColorScaleV,
  text: GlobalColorV
});

export const SingularityBrandColorV = t.type({
  neutral: t.union([NamedColorPaletteV, t.null]),
  primary: t.union([NamedColorPaletteV, t.null]),
  secondary: t.array(NamedColorPaletteV)
});

export type NamedColorPalette = t.TypeOf<typeof NamedColorPaletteV>;
export type ColorScale = t.TypeOf<typeof ColorScaleV>;
export type SingularityBrandColor = t.TypeOf<typeof SingularityBrandColorV>;

export const BORDER_RADIUS_VALUES = {
  none: {
    value: 0,
    unit: "px",
    style: "0px"
  } as unknown as UnitInputValue,
  sm: {
    value: 8,
    unit: "px",
    style: "8px"
  } as unknown as UnitInputValue,
  md: {
    value: 16,
    unit: "px",
    style: "16px"
  } as unknown as UnitInputValue,
  lg: {
    value: 24,
    unit: "px",
    style: "24px"
  } as unknown as UnitInputValue,
  full: {
    value: 9999,
    unit: "px",
    style: "9999px"
  } as unknown as UnitInputValue
};

export const BorderRadiusV = t.keyof(BORDER_RADIUS_VALUES);

export type BorderRadius = t.TypeOf<typeof BorderRadiusV>;

export const SingularityBrandUIV = t.type({
  buttonRadius: t.keyof(BORDER_RADIUS_VALUES),
  inputRadius: t.keyof(BORDER_RADIUS_VALUES)
});

export const SingularityBrandV = t.type({
  color: SingularityBrandColorV,
  ui: SingularityBrandUIV
});

export type SingularityBrand = t.TypeOf<typeof SingularityBrandV>;
